const cfg = window.__CONFIG__ || {};
const API_BASE = cfg.API_BASE || '';

export function getConfig() {
  return cfg;
}

export function getAccessToken() {
  try {
    return localStorage.getItem('access_token') || '';
  } catch {
    return '';
  }
}

export function clearAuth() {
  try {
    localStorage.removeItem('access_token');
    localStorage.removeItem('auth_code');
  } catch {
    // no-op
  }
}

export function getRefreshToken() {
  try {
    return localStorage.getItem('refresh_token') || '';
  } catch {
    return '';
  }
}

export async function apiFetch(path, options = {}) {
  const token = getAccessToken();
  const refreshToken = getRefreshToken();
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(token ? { 'x-auth-token': token } : {}),
    ...(refreshToken ? { 'x-refresh-token': refreshToken } : {}),
    ...(options.headers || {}),
  };

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });

  if (res.status === 401) {
    clearAuth();
    window.location.href = '/login';
    throw new Error('Session expired');
  }

  if (!res.ok) {
    const body = await res.text();
    const err = new Error(`Request failed: ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return { _raw: text };
  }
}

export function toCurrency(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return '';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
  }).format(Number(amount));
}

export function downloadCsv(filename, csvContent) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
